import { PaginationConfigType } from "@/types/message";
import { useState } from "react"






/**
 *  分页页码 hook
 * @param props 
 * @returns 
 */
const usePage = (props:any):PaginationConfigType => {
  const [pageSize, setPageSize] = useState<number>(props.pageSize || 10);
  const [currentPage, setCurrentPage] = useState<number>(props.currentPage || 1);
  const [total,setTotal] = useState<number>(props.total || 0);
  const [tableLoading,setTableLoading]=useState(false);
  return {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    total,
    setTotal,
    tableLoading,
    setTableLoading
  }
}

export default usePage